"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("./FlexPage.css");
var Box_1 = require("../../components/Box");
var classnames_1 = __importDefault(require("classnames"));
var useLayoutEffectState_1 = require("../../hooks/useLayoutEffectState");
var FlexPage = function (_a) {
  var _b, _c;
  var _d = _a.heightAdjust,
    heightAdjust = _d === void 0 ? "0px" : _d,
    className = _a.className,
    style = _a.style,
    children = _a.children,
    restProps = __rest(_a, ["heightAdjust", "className", "style", "children"]);
  var pageRef = (0, react_1.useRef)(null);
  var pageY = (_c = (_b = pageRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().y) !== null && _c !== void 0 ? _c : 0;
  var pageHeight = (0, useLayoutEffectState_1.useLayoutEffectState)({
    init: "0px",
    dependencies: [pageRef, pageY, heightAdjust],
    callback: function () {
      return "calc(100dvh - ".concat(pageY, "px - (").concat(heightAdjust, "))");
    }
  });
  var pageStyle = __assign(__assign({}, style), {
    height: pageHeight
  });
  return (0, jsx_runtime_1.jsx)(Box_1.Box, __assign({
    refObject: pageRef,
    style: pageStyle,
    className: (0, classnames_1.default)("vsx-flexpage", className)
  }, restProps, {
    children: children
  }));
};
exports.FlexPage = FlexPage;